import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../state/auth/auth.service';

export const authGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = await authService.user;
  if (!user) {
    return router.parseUrl('/');
  }
  return true;
};

export const adminGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = await authService.user;
  if (!user?.permissions.includes('analytics:read')) {
    return router.parseUrl('/home');
  }
  return true;
};

export const adminCFGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = await authService.user;
  if (!user?.permissions.includes('customerfeedback:read')) {
    return router.parseUrl('/home');
  }
  return true;
};

export const reverseAuthGuard: CanActivateFn = async (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = await authService.user;
  if (user) {
    return router.parseUrl('/home');
  }

  const urlParams = new URLSearchParams(window.location.search);
  const authCode = urlParams.get('code');

  if (authCode) {
    authService.autoSignIn(null);
  }

  return true;
};

export const autoLoginGuard: CanActivateFn = async (route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = await authService.user;
  const idp = route.queryParamMap.get('idp');
  if (!user) {
    authService.autoSignIn(idp);
  } else {
    return router.parseUrl('/home');
  }
  return true;
};
